import * as React from 'react'
import TableRow from '@mui/material/TableRow'
import { useData } from './hooks/useData'
import {
  Details,
  Dot,
  LeftCell,
  MiddleCell,
  Name,
  RightCell,
  Subtitle,
} from './styled'
import { ActivityHistory } from '@user/features/Activity/state'
import { Title } from './styled/Title.styled'

type Props = {
  historyElement: ActivityHistory
}

export function TreeNode(props: Props) {
  const {
    historyElement: { auditByUserName, auditByUserIsActive },
  } = props
  const {
    dateFormatted,
    subTitle,
    subTitle2,
    timeFormatted,
    title,
    updatedBy,
    isAssignmentUpdate,
    actionVerbiage,
  } = useData(props)

  const auditorUserName = React.useMemo(() => {
    if (!auditByUserIsActive) {
      return auditByUserName + ' (Inactive)'
    }
    return auditByUserName
  }, [auditByUserName, auditByUserIsActive])

  return (
    <TableRow>
      <LeftCell>
        <div>{dateFormatted}</div>
        <div>{timeFormatted}</div>
      </LeftCell>
      <MiddleCell>
        <Dot />
      </MiddleCell>
      <RightCell>
        <Name>{title}</Name>
        {isAssignmentUpdate ? (
          <Title>{subTitle}</Title>
        ) : (
          <Subtitle>{subTitle}</Subtitle>
        )}
        {subTitle2 && <Subtitle>{subTitle2}</Subtitle>}
        <Details>
          {actionVerbiage} - {updatedBy ?? auditorUserName}
        </Details>
      </RightCell>
    </TableRow>
  )
}
